import React from 'react';
import Card from 'src/components/Cards/Card';
import AvatarImage from 'shared/components/avatar-image';
import ReportUserButton from 'shared/report-user-button/containers';
import VerifyColleague from './verify-colleague';

interface Props {
  firstName: string;
  lastName: string;
  email: string;
  mobile?: string;
  image?: string;
  _id: string;
  isVerified: boolean;
  eligibleForVerificationAt: number;
}

const ColleagueInformationCard = ({
  _id,
  firstName,
  lastName,
  email,
  mobile,
  image,
  isVerified,
  eligibleForVerificationAt,
}: Props) => (
  <Card className="user-information-card">
    <div className="row user-information-card-container">
      <div className="user-information-card-avatar">
        <AvatarImage userInfo={{firstName, lastName, image}} />
      </div>
      <div className="user-information-card-info">
        <div className="user-information-card-name">
          {firstName} {lastName}
        </div>
        <div className="user-information-card-contact">{email || mobile}</div>
      </div>
      <div className="user-information-card-action">
        <ReportUserButton identifier={_id} name={`${firstName} ${lastName}`} />
        {!!eligibleForVerificationAt && !isVerified && (
          <span className="ml-12">
            <VerifyColleague id={_id} />
          </span>
        )}
      </div>
    </div>
  </Card>
);

export default ColleagueInformationCard;
